module.exports = __webpack_public_path__ + "img/login_signup_desktop.b1bfbc6a.png";